export var VoIpServerTypes;
(function (VoIpServerTypes) {
    VoIpServerTypes["3CX"] = "3CX";
    VoIpServerTypes["FreeSwitch"] = "FreeSwitch";
    VoIpServerTypes["Asterisk"] = "Asterisk";
    VoIpServerTypes["Other"] = "Other";
})(VoIpServerTypes || (VoIpServerTypes = {}));
